import { InstallmentRow } from 'components/Modal/HistoricoCobranca/components/Baixa/styled';
import styled from 'styled-components';

// Linha do estorno: mesmo cartao da baixa, com as colunas do titulo baixado.
export const ReversalRow = styled(InstallmentRow)`
  grid-template-columns: 40px 70px 1fr 1fr 1fr 1fr 1fr 1.6fr;
  padding-bottom: 8px;
  opacity: ${(props) => (props.$locked ? 0.65 : 1)};
`;

export const ReversalHeader = styled(ReversalRow)`
  border-color: transparent;
  background: transparent;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #718096;
  opacity: 1;
`;

// Justificativa, entre a lista e a barra de acoes.
export const ReasonField = styled.div`
  flex-shrink: 0;
`;
